import { useEffect, useState } from "react";

import type { UseThemePreferencesReturnType } from "./types";

export const useThemePreferences = (): UseThemePreferencesReturnType => {
  const getInitialPreferredTheme = () => {
    if (typeof window !== "undefined") {
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        return "dark";
      }

      return "light";
    }

    return "light";
  };

  const [preferredTheme, setPreferredTheme] = useState<"light" | "dark">(
    getInitialPreferredTheme(),
  );

  const handleBrowserPreferredThemeChange = ({
    matches,
  }: MediaQueryListEvent) => {
    if (matches) {
      setPreferredTheme("dark");
    } else {
      setPreferredTheme("light");
    }
  };

  useEffect(() => {
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", handleBrowserPreferredThemeChange);

    return () =>
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeEventListener("change", handleBrowserPreferredThemeChange);
  }, []);

  return { preferredTheme: preferredTheme };
};
